import { SET_PARENT_INFO, SET_EQUAL_TIME_PARENTS, SET_PARENT_TAX_INFO } from "./types";

export const updateParents = ( index=0, key='name', value='') => {
  return {
    type: SET_PARENT_INFO,
    payload: {index, key, value},
  };
};

export const updateParentsTaxInfo = ( index=0, type='stateRate', value='') => {
  return {
    type: SET_PARENT_TAX_INFO,
    payload: {index, type, value},
  };
};

export const setEqualTimeParents = ( isEqual ) => {
  return {
    type: SET_EQUAL_TIME_PARENTS,
    payload: isEqual,
  };
};

